import React, { useContext, useState,useEffect } from 'react';

import {
  Modal,
  useResponsiveParams,
  Button,
  useQuantaFormikContext,
  CountAnimation,
  Grid,
  QuantaToggle,
  InputGrid,
  MixedGridGroup,
  Text,
} from 'quanta-ui';
import {
  faCalculator,
  faExclamationCircle,
  faExclamationTriangle,
  faSave,
  faSpinner,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { ConfigContext } from '../../../../../lib/config/ConfigProvider';
import { CurrencyFormater, QuantaConfigContext } from 'quanta-flows';
// import Parse from '../../../../../lib/intl/CurrencyFormater';
import moment from 'moment';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
import { CALCULATE_PREMIUM_FOR_PROPOSAL_TW } from '../queries';
// import { updateViewRenewMotorPolicyVar } from '../_graphql/state';
import { updateViewRenewMotorPolicyVar } from 'quanta-flows/modules/policy/renewal/motor/state';
import { currency } from '../../../../../config/branding.config';

export default function ModalCovers({
  showCovers,
  setShowCovers,
  forwardedRef,
  forwardedAlertsRef,
  productCode,
  productName,
  productType,
  renewalMode,
  viewRenewMotorPolicy,
  proposalDetails,
  valuesBeforeEdit,
  validate,
}) {
  const fetchQuery = useFetchQuery();
  const MINOR_THRESHOLD_AGE = 18;
  const { values, setFieldValue, setValues } =
    useQuantaFormikContext();
  const { branding } = useContext(QuantaConfigContext);
  const [isCalculatingPremium, setCalculatingPremium] =
    useState(false);
  const [resultPremiumError, setResultPremiumError] = useState(null);
  const [warningMsg,setWarningMsg] = useState(null);
  const [premiumData, setPremiumData] = useState(null);
  const [showCalculatePremiumButton, setShowCalculatePremiumButton] =
    useState(false);
    const [tariffAddonCover, setTariffAddonCover] = useState([]);
    const [kgiAddonCover, setKgiAddonCover] = useState([]);
  let colSpan_for_mobile = 1;
  let colSpan_for_Desktop = 3;
  let repeat = useResponsiveParams({
    for_mobile: colSpan_for_mobile,
    for_desktop: colSpan_for_Desktop,
  });

  const screen = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
    for_iPad: 'ipad',
  });

  const getCalculatePremiumForProposalVariables = (values) => {
    let riskInput = [];
    let  trailerArr = [];
    viewRenewMotorPolicy?.quoteData?.trailerDetails?.forEach((_, idx) => {
     trailerArr.push({
         make: viewRenewMotorPolicy?.quoteData?.trailerDetails[idx].make,
         model:viewRenewMotorPolicy?.quoteData?.trailerDetails[idx].model,
         regnumber: viewRenewMotorPolicy?.quoteData?.trailerDetails[idx].regnumber,
         ChassisNumber:viewRenewMotorPolicy?.quoteData?.trailerDetails[idx].ChassisNumber,
         SI: viewRenewMotorPolicy?.quoteData?.trailerDetails[idx].SI,
         yearofmanufacture: viewRenewMotorPolicy?.quoteData?.trailerDetails[idx].yearofmanufacture,
       });
     });
     let prevInsurancedtls=[];
     viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV?.forEach((_, idx) => {
      prevInsurancedtls.push({
        coverType: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].coverType,
        policyTenure:viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].policyTenure,
        insurerName:viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].insurerName,
        policyNumber: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].policyNumber,
        startDate: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].startDate,
        expiryDate: viewRenewMotorPolicy?.quoteData?.prevInsuranceDetailsGCV[idx].expiryDate,
       });
     });
    viewRenewMotorPolicy?.coverData?.rawRiskData?.forEach((r) => {
      let covers = [];
      r.covers
        .filter((c) => values[`addOnCovers`][c?.name]?.selected)
        .forEach((c) => {
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${
                    values[`addOnCovers`][`${c?.name}`][`attributes`][
                      `${attribute?.name}`
                    ]
                  }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    return {
      input: {
        productCode,
        coverforlamps:viewRenewMotorPolicy?.IMT23?.toLowerCase()=='true'
        ?true:false,
        coverforprivateandcommercial:viewRenewMotorPolicy?.IMT34?.toLowerCase()=='true'
        ?true:false,
        productType: viewRenewMotorPolicy?.quoteData?.productType
          ? `${viewRenewMotorPolicy?.quoteData?.productType}`
          : '',
        customerType: viewRenewMotorPolicy?.proposerDetails
          ?.customerType
          ? `${viewRenewMotorPolicy?.proposerDetails?.customerType}`
          : '',
        gender: viewRenewMotorPolicy?.proposerDetails?.gender
          ? `${viewRenewMotorPolicy?.proposerDetails?.gender}`
          : '',
        businessType: viewRenewMotorPolicy?.quoteData?.businessType
          ? `${viewRenewMotorPolicy?.quoteData?.businessType}`
          : '',
        intermediary: {
          intermediaryCode: proposalDetails?.intermediaryData
            ?.intermediary
            ? `${proposalDetails?.intermediaryData?.intermediary}`
            : '',
          locationCode: proposalDetails?.intermediaryData
            ?.businessLocation
            ? `${proposalDetails?.intermediaryData?.businessLocation}`
            : '',
          fieldUserCode: proposalDetails?.intermediaryData?.fieldUser
            ? `${proposalDetails?.intermediaryData?.fieldUser}`
            : '',
        },
        tenure:
          viewRenewMotorPolicy?.quoteData?.tenure ||
          viewRenewMotorPolicy?.quoteData?.premiumData?.tenure
            ? `${
                viewRenewMotorPolicy?.quoteData?.tenure ||
                viewRenewMotorPolicy?.quoteData?.premiumData?.tenure
              }`
            : '',
        isTrailerRequired :viewRenewMotorPolicy?.quoteData?.isTrailerRequired,
        trailerDetails:trailerArr,
          rto: {
          rtoAuthCode: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoAuthorityCode
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoAuthorityCode}`
            : '',
          rtoLocCode: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationCode
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationCode}`
            : '',
          rtoLocDesc: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.rtoDetails?.rtoLocationDesc
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.rtoDetails?.rtoLocationDesc}`
            : '',
        },
        vehicle: {
          make: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.make?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.make?.code}`
            : '',
          model: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.model?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.model?.code}`
            : '',
          variant: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.variant?.code
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.variant?.code}`
            : '',
          engineNumber: proposalDetails?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.engineNumber
            ? `${proposalDetails?.vehicleTabDetails?.vehicleRegistrationDetails?.engineNumber}`
            : '',
          chasisNumber: proposalDetails?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.chasisNumber
            ? `${proposalDetails?.vehicleTabDetails?.vehicleRegistrationDetails?.chasisNumber}`
            : '',
          registrationNumber: proposalDetails?.vehicleTabDetails
            ?.vehicleRegistrationDetails?.registrationNumber
            ? `${proposalDetails?.vehicleTabDetails?.vehicleRegistrationDetails?.registrationNumber}`
            : '',
          manufactureYear: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.yearOfManufacture
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.yearOfManufacture}`
            : '',
          regPurchaseDate: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.dateOfRegistration
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.dateOfRegistration}`
            : '',
          fuelType: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.fuelType
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.fuelType}`
            : '',
          seatingCapacity: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.seatingCapacity
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.seatingCapacity}`
            : '',
          cubicCapacity: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.cubeCapacity
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.cubeCapacity}`
            : '',
          carryingCapacity: viewRenewMotorPolicy?.quoteData
            ?.carryingCapacity
            ? `${viewRenewMotorPolicy?.quoteData
              ?.carryingCapacity}`
            : '',
          gvw: viewRenewMotorPolicy?.quoteData
          ?.GVW
            ? `${viewRenewMotorPolicy?.quoteData
              ?.GVW}`
            : '',
          carriageType:viewRenewMotorPolicy?.quoteData
          ?.carriageType
            ? `${viewRenewMotorPolicy?.quoteData
              ?.carriageType}`
            : '',
          permitType:viewRenewMotorPolicy?.quoteData
          ?.permitType
            ? `${viewRenewMotorPolicy?.quoteData
              ?.permitType}`
            : '',
          vehicleuse : viewRenewMotorPolicy?.quoteData
          ?.vehicleUse
            ? `${viewRenewMotorPolicy?.quoteData
              ?.vehicleUse}`
            : '',
          vehicleSegment: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.vehicleSegment
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.vehicleSegment}`
            : '',
          sideCarValue:
            proposalDetails?.vehicleTabDetails?.insuredDeclaredDetails
              ?.sideCarValue !== null &&
            proposalDetails?.vehicleTabDetails?.insuredDeclaredDetails
              ?.sideCarValue !== undefined &&
            proposalDetails?.vehicleTabDetails?.insuredDeclaredDetails
              ?.sideCarValue !== ''
              ? `${proposalDetails?.vehicleTabDetails?.insuredDeclaredDetails?.sideCarValue}`
              : '',
          preInspectionNumber: viewRenewMotorPolicy?.vehicleTabDetails
            ?.vehicleDetails?.preInspectionNumber
            ? `${viewRenewMotorPolicy?.vehicleTabDetails?.vehicleDetails?.preInspectionNumber}`
            : '',
        },
        firstYearIDV:
          proposalDetails?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV !== null &&
          proposalDetails?.vehicleTabDetails?.insuredDeclaredDetails
            ?.vehicleIDV !== undefined
            ? `${proposalDetails?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV}`
            : ``,
        bodyIDV:proposalDetails?.vehicleTabDetails?.vehicleRegistrationDetails
        ?.bodyIDV !== null &&
      proposalDetails?.vehicleTabDetails?.vehicleRegistrationDetails
        ?.bodyIDV !== undefined
        ? `${proposalDetails?.vehicleTabDetails?.vehicleRegistrationDetails?.bodyIDV}`
        : ``,
        totalIDV: (parseFloat(
          proposalDetails?.vehicleTabDetails?.vehicleRegistrationDetails?.bodyIDV)
           +parseFloat(proposalDetails?.vehicleTabDetails?.insuredDeclaredDetails?.vehicleIDV))?.toString(),
        irf1: proposalDetails?.vehicleTabDetails
          ?.insuredDeclaredDetails?.irfAdjustmentPercent
          ? `${proposalDetails?.vehicleTabDetails?.insuredDeclaredDetails?.irfAdjustmentPercent}`
          : '',
        prevInsurance: {
          coverType: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyCoverType
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyCoverType}`
            : '',
          policyTenure: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyTenure
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenure}`
            : '',
          insurerName: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.previousInsurerName
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.previousInsurerName}`
            : '',
          policyNumber: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.expiringPolicyNumber
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.expiringPolicyNumber}`
            : '',
          startDate: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyStartDate
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyStartDate}`
            : '',
          expiryDate: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousPolicyDetails
            ?.policyExpiryDate
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyExpiryDate}`
            : '',
        },
        prevClaims: {
          totalClaimCount:
            viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'annual'
              ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.totalClaimCount}`
              : '',
          claimsInYear1:
            viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term'
              ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear1}`
              : '',
          claimsInYear2:
            viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term'
              ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear2}`
              : '',
          claimsInYear3:
            viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousPolicyDetails?.policyTenureValue?.toLowerCase() ===
            'long term'
              ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.noOfClaimsYear3}`
              : '',
          prevNCBSlab: viewRenewMotorPolicy?.additionalTabDetails
            ?.previousInsuranceAndClaims?.previousClaims
            ?.previousYearNCBSlab
            ? `${viewRenewMotorPolicy?.additionalTabDetails?.previousInsuranceAndClaims?.previousClaims?.previousYearNCBSlab}`
            : '',
          claimFreeYear:
            viewRenewMotorPolicy?.quoteData?.premiumData
              ?.claimFreeYear ||
            viewRenewMotorPolicy?.premiumData?.claimFreeYear,
          totalClaimAmount:
            viewRenewMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount !== undefined &&
            viewRenewMotorPolicy?.additionalTabDetails
              ?.previousInsuranceAndClaims?.previousClaims
              ?.totalClaimAmount !== null
              ? parseFloat(
                  viewRenewMotorPolicy?.additionalTabDetails
                    ?.previousInsuranceAndClaims?.previousClaims
                    ?.totalClaimAmount,
                )
              : null,
        },
        prevInsuranceGCV:prevInsurancedtls,
        financerDetails: {
          financerName:
            proposalDetails?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? proposalDetails?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.financerName
              : '',
          financerAddress:
            proposalDetails?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? proposalDetails?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.financerAddress
              : '',
          financerAgreementType:
            proposalDetails?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? proposalDetails?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.financerAgreementType
              : '',
          loanAccountNumber:
            proposalDetails?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? proposalDetails?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.loanAccountNumber
              : '',
          fileNumber:
            proposalDetails?.additionalTabDetails?.financeDetails?.vehicleOwned?.toLowerCase() ===
            'financed'
              ? proposalDetails?.additionalTabDetails?.financeDetails
                  ?.financerDetails?.fileNumber
              : '',
        },
        nomineeDetails:{
          name: proposalDetails?.additionalTabDetails?.nomineeDetails?.nomineeName
          ? `${proposalDetails?.additionalTabDetails?.nomineeDetails?.nomineeName}`
          : '',
          dob: proposalDetails?.additionalTabDetails?.nomineeDetails?.nomineeDob
          ? `${proposalDetails?.additionalTabDetails?.nomineeDetails?.nomineeDob}`
          : '',
          relationshipWithInsured:proposalDetails?.additionalTabDetails?.nomineeDetails?.relationshipWithInsured
          ? `${proposalDetails?.additionalTabDetails?.nomineeDetails?.relationshipWithInsured}`
          : '',
          insuredRelationship: proposalDetails?.additionalTabDetails?.nomineeDetails?.relationshipWithNominee
          ? `${proposalDetails?.additionalTabDetails?.nomineeDetails?.relationshipWithNominee}`
          : '',
          nameOfAppointee:proposalDetails?.additionalTabDetails?.nomineeDetails?.nameOfAppointee
          ? `${proposalDetails?.additionalTabDetails?.nomineeDetails?.nameOfAppointee}`
          : '',
          relationshipWithAppointee:proposalDetails?.additionalTabDetails?.nomineeDetails?.relationshipWithAppointee
          ? `${proposalDetails?.additionalTabDetails?.nomineeDetails?.relationshipWithAppointee}`
          : '',
        },
        riskCovers: riskInput,
        creditScore: {
          discountOpted:
            viewRenewMotorPolicy?.quoteData
              ?.getAdditionalCreditScore === 'Yes',
          idProofType: viewRenewMotorPolicy?.quoteData?.idProofType,
          idProofNumber:
            viewRenewMotorPolicy?.quoteData?.idProofNumber,
          creditScore:
            viewRenewMotorPolicy?.quoteData?.premiumData
              ?.creditScore !== null &&
            viewRenewMotorPolicy?.quoteData?.premiumData
              ?.creditScore !== undefined
              ? parseFloat(
                  viewRenewMotorPolicy?.quoteData?.premiumData
                    ?.creditScore,
                )
              : null,
        },
        proposerPincode: viewRenewMotorPolicy?.quoteData?.pincode,
        voluntaryDeductibleAmt:
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== null &&
          viewRenewMotorPolicy?.quoteData
            ?.voluntaryDeductibleAmount !== undefined
            ? parseFloat(
                viewRenewMotorPolicy?.quoteData
                  ?.voluntaryDeductibleAmount,
              )
            : null,
        quoteNumber: viewRenewMotorPolicy?.quoteNumber,
        customer: {
          id: viewRenewMotorPolicy?.proposerDetails?.id,
          customerType:
            viewRenewMotorPolicy?.proposerDetails?.customerType,
          isThinCustomer: false,
          title: viewRenewMotorPolicy?.proposerDetails?.title,
          gender: viewRenewMotorPolicy?.proposerDetails?.gender,
          firstName: viewRenewMotorPolicy?.proposerDetails?.firstName,
          middleName:
            viewRenewMotorPolicy?.proposerDetails?.middleName,
          lastName: viewRenewMotorPolicy?.proposerDetails?.lastName,
          fullName: viewRenewMotorPolicy?.proposerDetails?.fullName,
          proposerDOB:
            viewRenewMotorPolicy?.proposerDetails?.proposerDOB,
          maritalStatus:
            viewRenewMotorPolicy?.proposerDetails?.maritalStatus,
          occupation:
            viewRenewMotorPolicy?.proposerDetails?.occupation,
          nationality:
            viewRenewMotorPolicy?.proposerDetails?.nationality,
          idProofType:
            viewRenewMotorPolicy?.proposerDetails?.idProofType,
          idProofNumber:
            viewRenewMotorPolicy?.proposerDetails?.idProofNumber,
          panNumber: viewRenewMotorPolicy?.proposerDetails?.panNumber,
          orgName: viewRenewMotorPolicy?.proposerDetails?.orgName,
          orgType: viewRenewMotorPolicy?.proposerDetails?.orgType,
          contactName:
            viewRenewMotorPolicy?.proposerDetails?.contactName,
          regNumber: viewRenewMotorPolicy?.proposerDetails?.regNumber,
          tanNumber: viewRenewMotorPolicy?.proposerDetails?.tanNumber,
          gstNumber: viewRenewMotorPolicy?.proposerDetails?.gstNumber,
          permAddressLine1:
            proposalDetails?.proposerDetails?.permAddressLine1,
          permAddressLine2:
            proposalDetails?.proposerDetails?.permAddressLine2,
          permAddressLine3:
            proposalDetails?.proposerDetails?.permAddressLine3,
          permLandmark:
            proposalDetails?.proposerDetails?.permLandmark,
          permPincode: proposalDetails?.proposerDetails?.permPincode,
          permCityTownVillage:
            proposalDetails?.proposerDetails?.permCityTownVillage,
          permDistrict:
            proposalDetails?.proposerDetails?.permDistrict,
          permState: proposalDetails?.proposerDetails?.permState,
          permCommAddressYN: proposalDetails?.proposerDetails
            ?.permCommAddressYN
            ? true
            : false,
          commAddressLine1:
            proposalDetails?.proposerDetails?.commAddressLine1,
          commAddressLine2:
            proposalDetails?.proposerDetails?.commAddressLine2,
          commAddressLine3:
            proposalDetails?.proposerDetails?.commAddressLine3,
          commLandmark:
            proposalDetails?.proposerDetails?.commLandmark,
          commPincode: proposalDetails?.proposerDetails?.commPincode,
          commCityTownVillage:
            proposalDetails?.proposerDetails?.commCityTownVillage,
          commDistrict:
            proposalDetails?.proposerDetails?.commDistrict,
          commState: proposalDetails?.proposerDetails?.commState,
          phoneNo: viewRenewMotorPolicy?.proposerDetails?.phoneNo,
          mobileNo: proposalDetails?.proposerDetails?.mobileNo,
          emailID: proposalDetails?.proposerDetails?.emailID,
          faxNo: viewRenewMotorPolicy?.proposerDetails?.faxNo,
          altPhoneNo:
            viewRenewMotorPolicy?.proposerDetails?.altPhoneNo,
          altMobileNo:
            viewRenewMotorPolicy?.proposerDetails?.altMobileNo,
          ifscCode:
            viewRenewMotorPolicy?.proposerDetailsMeta?.ifscCode,
          bankName:
            viewRenewMotorPolicy?.proposerDetailsMeta?.bankName,
          branchName:
            viewRenewMotorPolicy?.proposerDetailsMeta?.branchName,
          bankAcno:
            viewRenewMotorPolicy?.proposerDetailsMeta?.bankAcno,
          accountHolderName:
            viewRenewMotorPolicy?.proposerDetailsMeta
              ?.accountHolderName,
          micrCode:
            viewRenewMotorPolicy?.proposerDetailsMeta?.micrCode,
          employeeNumber:
            viewRenewMotorPolicy?.proposerDetails?.employeeNumber,
        },
        proposalNumber: viewRenewMotorPolicy?.proposalNumber,
        policyNumber: '',
        //policyNumber: viewRenewMotorPolicy?.policyNumber,
        leadGenerator: viewRenewMotorPolicy
          ?.reviewAndConfirmTabDetails?.leadGenerator
          ? `${viewRenewMotorPolicy?.reviewAndConfirmTabDetails?.leadGenerator}`
          : '',
        proposalPaymentType:
          proposalDetails?.reviewAndConfirmTabDetails
            ?.proposalPaymentType,
        modeOfOperation: renewalMode,
        startDate: viewRenewMotorPolicy?.policy?.startDate
          ? `${viewRenewMotorPolicy?.policy?.startDate}`
          : '',
        endDate: viewRenewMotorPolicy?.policy?.endDate
          ? `${viewRenewMotorPolicy?.policy?.endDate}`
          : '',
      },
    };
  };

  let premiumGridData = [
    // {
    //   type: 'select',
    //   label: (
    //     <Text type="label">
    //       Tenure <Text severity="error">*</Text>
    //     </Text>
    //   ),
    //   size: 'large',
    //   disabled: true,
    //   data: viewRenewMotorPolicy?.coverData?.tenureList
    //     ? [
    //         ...Array.from(
    //           new Set(viewRenewMotorPolicy?.coverData?.tenureList),
    //         ).map((tenure) => {
    //           return {
    //             label: `${tenure}${
    //               tenure?.search('years') === -1
    //                 ? ` year${tenure === '1' ? '' : 's'}`
    //                 : ''
    //             }`,
    //             value: tenure,
    //           };
    //         }),
    //       ]
    //     : [],
    //   name: 'premiumData.tenure',
    // },
    {
      type: 'render',
      component: () => (
        <div className="flex flex-col space-y-1 mt-4">
          <Text
            type="label"
            severity="info"
            className={showCalculatePremiumButton ? 'mb-0.5' : ''}
          >
            Annual Premium (inclusive of taxes)
          </Text>

          {showCalculatePremiumButton && (
            <Button
              flat={false}
              className={'w-4/6'}
              disabled={
                validate(values)?.addOnCovers &&
                Object.keys(validate(values)?.addOnCovers)?.length > 0
              }
              iconPre={<FontAwesomeIcon icon={faCalculator} />}
              size={'medium'}
              onClick={async (_) => {
                setShowCalculatePremiumButton(false);
                try {
                  setResultPremiumError(null);
                  setWarningMsg(null);
                  const getCalculatePremiumQuery = fetchQuery({
                    query: CALCULATE_PREMIUM_FOR_PROPOSAL_TW,
                    fetchPolicy: 'network-only',
                    variables:
                      getCalculatePremiumForProposalVariables(values),
                  });
                  setCalculatingPremium(true);
                  const { data } = await getCalculatePremiumQuery;
                  setPremiumData(data);
                  if (
                    data?.gcvcalculatePremiumProposal?.warningMsg
                  ) {
                    setWarningMsg(
                      data?.gcvcalculatePremiumProposal?.warningMsg,
                    );
                  }
                  setCalculatingPremium(false);
                } catch (error) {
                  setCalculatingPremium(false);
                  if(error?.message?.includes("Unexpected token")){
                    setResultPremiumError('Please try again after sometime');
                  }
                  else{
                  setResultPremiumError(error?.message);
                  }
                  setWarningMsg(null);
                }
              }
            }
            >
              Recalculate
            </Button>
          )}
          {!showCalculatePremiumButton && (
            <Text
              severity="info"
              className="flex space-x-2 items-center"
            >
              {isCalculatingPremium ? (
                <>
                  <Text type="normal">
                    <FontAwesomeIcon icon={faSpinner} spin={true} />
                  </Text>
                  <Text>Calculating Premium</Text>
                </>
              ) : resultPremiumError ? (
                <>
                  <Text type="normal" severity="error">
                    <FontAwesomeIcon icon={faExclamationCircle} />
                  </Text>
                  <Text severity="error">
                    Error Calculating Premium
                  </Text>
                </>
              ) : premiumData?.gcvcalculatePremiumProposal
                  ?.totalPremium ||
                values?.premiumData?.totalPremium ? (
                <Text
                  severity="info"
                  type="larger"
                  className="flex space-x-2"
                >
                  <CountAnimation
                    end={
                      premiumData?.gcvcalculatePremiumProposal
                        ?.totalPremium ||
                      values?.premiumData?.totalPremium
                    }
                    duration={1}
                    decimals={2}
                    prefix={branding.currency + ' '}
                    formattingFn={(num) => {
                      return CurrencyFormater(num, true, false, branding, true);
                    }}
                  />
                </Text>
              ) : null}
            </Text>
          )}
        </div>
      ),
    },
    
    //sessionStorage?.getItem('addOnCoversError')?.toString() !== '' ? {
      validate(values)?.addOnCoversError ? {
      type: 'render',
      colSpan: repeat,
      component: () => (
        <Text severity={'error'} className={'flex space-x-2'}>
          <Text>
            <FontAwesomeIcon icon={faExclamationCircle} />
          </Text>
          <Text>{validate(values)?.addOnCoversError }</Text>
        </Text>
      ),
    }
  : null,
    resultPremiumError
      ? {
          type: 'render',
          colSpan: repeat,
          component: () => (
            <Text severity={'error'} className={'flex space-x-2'}>
              <Text>
                <FontAwesomeIcon icon={faExclamationCircle} />
              </Text>
              <Text>{resultPremiumError}</Text>
            </Text>
          ),
        }
      : null,
    warningMsg
      ? {
        type: 'render',
        colSpan: repeat,
        component: () => (
          <Text severity={'warning'} className={'flex space-x-2'}>
            <Text>
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </Text>
            <Text>{warningMsg}</Text>
          </Text>
        ),
        }
      : null,
  ].filter((d) => d);
  useEffect(() => {
    let KgiAddOn = [ 'N380579G0039','N380579G0042','N380579G0041','N380579G0043','N380579G0044','N380579G0045','N380579G0046','N380579G0047','N380579G0048','N380579G0049','N380579G0050','N380579G0040',];
    let AdditionalAddOn =  [];
    let TraiffAddOn = ['N380579G0008' ,'N380579G0035' ,'N380579G0015' ,'N380579G0037','N380579G0038','N380579G0016','N380579G0023','N380579G0025','N380579G0024', 'N380579G0009','N380579G0018'];
    let kgiAddonCoverList =[];
    let tariffAddonCoverList =[];
    let AdditionalAddonCoverList =[];
     let coverInde = [] ;
     viewRenewMotorPolicy?.coverData?.rawRiskData?.map((riskCover, idx) =>{
      riskCover.covers.map((cover, idx) =>{
        coverInde.push(cover?.index);
        if(KgiAddOn?.find((e)=> e === cover?.index)){
          kgiAddonCoverList?.push(cover);
        }else if(AdditionalAddOn?.find((e)=> e === cover?.index)){
          AdditionalAddonCoverList?.push(cover);
        }else if(TraiffAddOn?.find((e)=> e === cover?.index)){
          tariffAddonCoverList?.push(cover);
        }
      })
     });
    setTariffAddonCover(tariffAddonCoverList);
    setKgiAddonCover(kgiAddonCoverList);
  },[viewRenewMotorPolicy?.coverData?.rawRiskData]);
  const attributeData = (attributes, coverName) => {
    return attributes
      ? attributes
          .filter((attr) => attr.showOnScreen)
          .map((attribute) => {
            return attribute.fieldDataType === 'amount'
              ? {
                  type: `${attribute.fieldType}`,
                  label: (
                    <Text type={'label'}>
                      {attribute.displayName}{' '}
                      <Text severity="error">*</Text>
                    </Text>
                  ),
                  name: `addOnCovers.${coverName}.attributes.${attribute.name}`,
                  disabled:
                    isCalculatingPremium ||
                    viewRenewMotorPolicy?.isProposalRenewed,
                  className: `${
                    isCalculatingPremium ||
                    viewRenewMotorPolicy?.isProposalRenewed
                      ? 'border-neutral-dark'
                      : ''
                  }`,
                  iconPre: (
                    <Text
                      severity={
                        isCalculatingPremium ||
                        viewRenewMotorPolicy?.isProposalRenewed
                          ? 'neutral-darker'
                          : 'info'
                      }
                    >
                      {branding.currency}
                    </Text>
                  ),
                  data:
                    attribute.fieldType === 'select'
                      ? attribute.dataValues.map((dataval) => {
                          return {
                            label: dataval.value,
                            value: dataval.code,
                          };
                        })
                      : undefined,
                  onDataChange: (val, _) => {
                    if (!showCalculatePremiumButton) {
                      setShowCalculatePremiumButton(true);
                    }
                  },
                }
              : {
                  type: `${attribute.fieldType}`,
                  label: (
                    <Text type={'label'}>
                      {attribute.displayName}{' '}
                      <Text severity="error">*</Text>
                    </Text>
                  ),
                  name: `addOnCovers.${coverName}.attributes.${attribute.name}`,
                  disabled:
                    ((attribute?.displayName?.toLowerCase() ===
                      'name of appointee' ||
                      attribute?.displayName?.toLowerCase() ===
                        'relationship of appointee') &&
                      moment(new Date(), 'DD/MM/YYYY').diff(
                        moment(
                          values?.addOnCovers[`${coverName}`][
                            `attributes`
                          ][
                            `${
                              attributes
                                .filter((attr) => attr.showOnScreen)
                                ?.find(
                                  (attr) =>
                                    attr?.displayName?.toLowerCase() ===
                                    'nominee dob',
                                )?.name
                            }`
                          ],
                          'DD/MM/YYYY',
                        ),
                        'years',
                      ) >= MINOR_THRESHOLD_AGE) ||
                    isCalculatingPremium ||
                    viewRenewMotorPolicy?.isProposalRenewed,
                  data:
                    attribute.fieldType === 'select'
                      ? attribute.dataValues.map((dataval) => {
                          return {
                            label: dataval.value,
                            value: dataval.code,
                          };
                        })
                      : undefined,
                  onDataChange: (val, _) => {
                    if (!showCalculatePremiumButton) {
                      setShowCalculatePremiumButton(true);
                    }
                    if (
                      attribute?.displayName?.toLowerCase() ===
                        'nominee dob' &&
                      moment(new Date(), 'DD/MM/YYYY').diff(
                        moment(val, 'DD/MM/YYYY'),
                        'years',
                      ) >= MINOR_THRESHOLD_AGE
                    ) {
                      setFieldValue(
                        `addOnCovers.${coverName}.attributes.${
                          attributes
                            .filter((attr) => attr.showOnScreen)
                            ?.find(
                              (attr) =>
                                attr?.displayName?.toLowerCase() ===
                                'name of appointee',
                            )?.name
                        }`,
                        '',
                      );
                      setFieldValue(
                        `addOnCovers.${coverName}.attributes.${
                          attributes
                            .filter((attr) => attr.showOnScreen)
                            ?.find(
                              (attr) =>
                                attr?.displayName?.toLowerCase() ===
                                'relationship of appointee',
                            )?.name
                        }`,
                        '',
                      );
                    }
                  },
                };
          })
      : [];
  };

  const other_props_attribute_form = {
    flow: 'cols',
    repeat,
    gapX: 8,
    gapY: 0.5,
    size: 'full',
  };

  const data = [
    // {
    //   grid_type: 'data',
    //   grid_data: [
    //     {
    //       colSpan: colSpan_for_Desktop,
    //       text: (
    //         // <>
    //         //   <InputGrid
    //         //     data={premiumGridData}
    //         //     repeat={repeat}
    //         //     titleType="title"
    //         //     gapX={6}
    //         //     titleSeverity="info"
    //         //   />
    //         // </>
    //       ),
    //     },
    //   ],
    // },
    !resultPremiumError &&
    (premiumData?.gcvcalculatePremiumProposal?.idv1 ||
      premiumData?.gcvcalculatePremiumProposal?.idv2 ||
      premiumData?.gcvcalculatePremiumProposal?.idv3 ||
      viewRenewMotorPolicy?.premiumData?.idv1 ||
      viewRenewMotorPolicy?.premiumData?.idv2 ||
      viewRenewMotorPolicy?.premiumData?.idv3)
      ? {
          grid_type: 'data',
          grid_data: [
            {
              label: 'First Year Insured Declared Value(IDV)',
              text: CurrencyFormater(
                premiumData?.gcvcalculatePremiumProposal?.idv1 ||
                  viewRenewMotorPolicy?.premiumData?.idv1,
                true,
                false,
                branding,
                true,
              ),
              // <CountAnimation
              //   end={parseFloat(
              //     premiumData?.gcvcalculatePremiumProposal
              //       ?.idv1 ||
              //       viewRenewMotorPolicy?.premiumData?.idv1,
              //   )}
              //   duration={1}
              //   decimals={2}
              //   prefix={branding.currency + ' '}
              //   formattingFn={(num) => {
              //     return Parse(num, true, false, branding, true);
              //   }}
              // />
            },
            // {
            //   label: 'Second Year Insured Declared Value(IDV)',
            //   text: CurrencyFormater(
            //     premiumData?.gcvcalculatePremiumProposal?.idv2 ||
            //       viewRenewMotorPolicy?.premiumData?.idv2,
            //     true,
            //     false,
            //     branding,
            //     true,
            //   ),
              // <CountAnimation
              //   end={parseFloat(
              //     premiumData?.gcvcalculatePremiumProposal
              //       ?.idv2 ||
              //       viewRenewMotorPolicy?.premiumData?.idv2,
              //   )}
              //   duration={1}
              //   decimals={2}
              //   prefix={branding.currency + ' '}
              //   formattingFn={(num) => {
              //     return Parse(num, true, false, branding, true);
              //   }}
              // />
            // },
            // {
            //   label: 'Third Year Insured Declared Value(IDV)',
            //   text: CurrencyFormater(
            //     premiumData?.gcvcalculatePremiumProposal?.idv3 ||
            //       viewRenewMotorPolicy?.premiumData?.idv3,
            //     true,
            //     false,
            //     branding,
            //     true,
            //   ),
            //   // <CountAnimation
            //   //   end={parseFloat(
            //   //     premiumData?.gcvcalculatePremiumProposal
            //   //       ?.idv3 ||
            //   //       viewRenewMotorPolicy?.premiumData?.idv3,
            //   //   )}
            //   //   duration={1}
            //   //   decimals={2}
            //   //   prefix={branding.currency + ' '}
            //   //   formattingFn={(num) => {
            //   //     return Parse(num, true, false, branding, true);
            //   //   }}
            //   // />
            // },
            (premiumData?.gcvcalculatePremiumProposal
              ?.vehicleAge !== null &&
              premiumData?.gcvcalculatePremiumProposal
                ?.vehicleAge !== undefined &&
              premiumData?.gcvcalculatePremiumProposal
                ?.vehicleAge !== '') ||
            (viewRenewMotorPolicy?.premiumData?.vehicleAge !== null &&
              viewRenewMotorPolicy?.premiumData?.vehicleAge !==
                undefined &&
              viewRenewMotorPolicy?.premiumData?.vehicleAge !== '')
              ? {
                  label: 'Vehicle Age',
                  text: `${
                    premiumData?.gcvcalculatePremiumProposal
                      ?.vehicleAge ||
                    viewRenewMotorPolicy?.premiumData?.vehicleAge
                  } year(s)`,
                }
              : null,
          ].filter((d) => d),
        }
      : null,
  ].filter((d) => d);
  const kgiAddonData=[
    {
      title: 'Add-On Covers',
      grid_type: 'data',
      grid_data: [
        {
          colSpan: colSpan_for_Desktop,
          text: (
            <div className="mt-2">
              <div>
                    {/* <Text severity="info">Add-on Covers</Text> */}
                    <Grid repeat={1} className="mt-8">
                      <Grid repeat={2}>
                          { kgiAddonCover?.map((cover, idx) => (
                          <div key={idx}>
                            <QuantaToggle
                              label={cover?.name}
                              name={`addOnCovers.${cover?.name}.selected`}
                              disabled={
                                isCalculatingPremium ||
                                viewRenewMotorPolicy?.isProposalRenewed 
                              //   ||
                              // (   ( (!values?.addOnCovers[cover?.name]?.selected &&
                              //      !values?.addOnCovers[cover?.name]?.isRenewalSelected) 
                              //      && ( (cover?.name === 'Consumable Cover' 
                              //        && values?.addOnCovers['Depreciation Cover']?.selected ) ? false : true)
                              // //  (values?.addOnCovers['Return to Invoice']?.isRenewalSelected || 
                              // //  values?.addOnCovers['Engine Protect']?.isRenewalSelected ||
                              // //  values?.addOnCovers['Consumable Cover']?.isRenewalSelected  ) 
                              //  )
                              //   ? true : false  ) 
                              }
                              onChange={(val) => {
                                setFieldValue(
                                  `addOnCovers.${cover?.name}.selected`,
                                  val,
                                );
                                if (!val) {
                                  cover?.attributes?.forEach(
                                    (attribute) => {
                                      setFieldValue(
                                        `addOnCovers.${cover?.name}.attributes.${attribute?.name}`,
                                        '',
                                      );
                                    },
                                  );
                                }
                                setShowCalculatePremiumButton(true);
                              }}
                            />
                            {values?.addOnCovers[`${cover?.name}`]
                              ?.selected && (
                              <InputGrid
                                {...{
                                  data: attributeData(
                                    cover?.attributes,
                                    cover?.name,
                                  ),
                                  ...other_props_attribute_form,
                                }}
                              />
                            )}
                          </div>
                        ))}
                      </Grid>
                </Grid>
              </div>
            </div>
                    ),
        },
      ],
    },
  ]
  const tarifAddOn=[
    {
      title: "Tariff's Add-on Covers",
      grid_type: 'data',
      grid_data: [
        {
          colSpan: colSpan_for_Desktop,
          text: (
            <div className="mt-2">
              <div>
                    {/* <Text severity="info">Add-on Covers</Text> */}
                    <Grid repeat={1} className="mt-8">
                      <Grid repeat={2}>
                          { tariffAddonCover?.map((cover, idx) => (
                          <div key={idx}>
                            <QuantaToggle
                              label={cover?.name}
                              name={`addOnCovers.${cover?.name}.selected`}
                              disabled={
                                isCalculatingPremium ||
                                viewRenewMotorPolicy?.isProposalRenewed 
                              //   ||
                              // (   ( (!values?.addOnCovers[cover?.name]?.selected &&
                              //      !values?.addOnCovers[cover?.name]?.isRenewalSelected) 
                              //      && ( (cover?.name === 'Consumable Cover' 
                              //        && values?.addOnCovers['Depreciation Cover']?.selected ) ? false : true)
                              // //  (values?.addOnCovers['Return to Invoice']?.isRenewalSelected || 
                              // //  values?.addOnCovers['Engine Protect']?.isRenewalSelected ||
                              // //  values?.addOnCovers['Consumable Cover']?.isRenewalSelected  ) 
                              //  )
                              //   ? true : false  ) 
                              }
                              onChange={(val) => {
                                setFieldValue(
                                  `addOnCovers.${cover?.name}.selected`,
                                  val,
                                );
                                if (!val) {
                                  cover?.attributes?.forEach(
                                    (attribute) => {
                                      setFieldValue(
                                        `addOnCovers.${cover?.name}.attributes.${attribute?.name}`,
                                        '',
                                      );
                                    },
                                  );
                                }
                                setShowCalculatePremiumButton(true);
                              }}
                            />
                            {values?.addOnCovers[`${cover?.name}`]
                              ?.selected && (
                              <InputGrid
                                {...{
                                  data: attributeData(
                                    cover?.attributes,
                                    cover?.name,
                                  ),
                                  ...other_props_attribute_form,
                                }}
                              />
                  )}
                          </div>
                        ))}
                      </Grid>
                </Grid>
              </div>
            </div>
          ),
        },
      ],
    },
  ]
  const other_props = {
    flow: 'cols',
    textType: 'normal',
    repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info',
    useExpandablePaper: false,
  };

    const other_props1 = {
      flow: 'cols',
      textType: 'normal',
      repeat,
      gapX: 2,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true,
    };
  return (
    <div className="text-black font-normal">
      <Modal
        display={showCovers}
        size={screen === 'desktop' ? 'large' : 'full'}
        title={`Your Cover Details`}
        className="h-screen flex flex-col justify-start"
        onClose={(e) => {
          setValues(valuesBeforeEdit);
          setShowCovers(false);
          setResultPremiumError(null);
          setShowCalculatePremiumButton(false);
          setPremiumData(null);
          setWarningMsg(null);
        }}
        severity={'action'}
        modalCloseDisabled={isCalculatingPremium}
      >
        <MixedGridGroup {...{ data, ...other_props }} />
        <MixedGridGroup {...{ data:kgiAddonData, ...other_props1 }} />
        <MixedGridGroup {...{ data:tarifAddOn, ...other_props1 }} />
        <>
              <InputGrid
                data={premiumGridData}
                repeat={repeat}
                titleType="title"
                gapX={6}
                titleSeverity="info"
              />
            </>
        <div className="flex justify-end items-baseline w-full space-x-2 pb-2">
          <span>
            <Button
              type={'button'}
              size={'small'}
              iconPre={
                <FontAwesomeIcon icon={faSave} className={'ml-2'} />
              }
              className="w-24"
              disabled={
                // resultPremiumError !== null ||
                viewRenewMotorPolicy?.isProposalRenewed ||
                // showCalculatePremiumButton ||
                isCalculatingPremium ||
                (validate(values)?.addOnCovers &&
                  Object.keys(validate(values)?.addOnCovers)?.length >
                    0)
              }
              onClick={(_) => {
                setShowCovers(false);
                updateViewRenewMotorPolicyVar({
                  premiumData: {
                    ...(premiumData?.gcvcalculatePremiumProposal ||
                      values?.premiumData),
                    tenure:
                      viewRenewMotorPolicy?.premiumData?.tenure ||
                      viewRenewMotorPolicy?.quoteData?.premiumData
                        ?.tenure ||
                      viewRenewMotorPolicy?.quoteData?.tenure,
                    creditScore:
                      viewRenewMotorPolicy?.premiumData?.creditScore,
                  },
                  coverData: {
                    ...viewRenewMotorPolicy?.coverData,
                    addOnCovers: values?.addOnCovers,
                  },
                  // enablecalcrenew:false,
                  additionalTabDetails:{
                    ...viewRenewMotorPolicy?.additionalTabDetails,
                  nomineeDetails: {
                    nomineeName: values?.addOnCovers?.[`Owner Driver`]?.selected!==true
                    ?'':viewRenewMotorPolicy?.additionalTabDetails
                    ?.nomineeDetails?.nomineeName,
                    nomineeDob:values?.addOnCovers?.[`Owner Driver`]?.selected!==true
                    ?'':viewRenewMotorPolicy?.additionalTabDetails
                    ?.nomineeDetails?.nomineeDob,
                    relationshipWithNominee: values?.addOnCovers?.[`Owner Driver`]?.selected!==true
                    ?'':viewRenewMotorPolicy?.additionalTabDetails
                    ?.nomineeDetails?.relationshipWithNominee,
                    nameOfAppointee: values?.addOnCovers?.[`Owner Driver`]?.selected!==true
                    ?'':viewRenewMotorPolicy?.additionalTabDetails
                    ?.nomineeDetails?.nameOfAppointee,
                    relationshipWithAppointee: values?.addOnCovers?.[`Owner Driver`]?.selected!==true
                    ?'':viewRenewMotorPolicy?.additionalTabDetails
                    ?.nomineeDetails?.relationshipWithAppointee,
                  },},
                  quoteData: {
                    ...viewRenewMotorPolicy?.quoteData,
                    premiumData:
                      premiumData?.gcvcalculatePremiumProposal ||
                      values?.premiumData,
                  },
                });
                setPremiumData(null);
                forwardedAlertsRef.current = [
                  {
                    id: Date.now(),
                    content: (
                      <div>Add on covers updated successfully</div>
                    ),
                    timeout: 7000,
                    disableClose: false,
                    type: 'info',
                  },
                ];
                document.body.classList.remove('overflow-y-hidden');
              }}
            >
              Save
            </Button>
          </span>
          <span>
            <Button
              flat={true}
              type={'button'}
              size={'small'}
              iconPre={
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  className={'ml-2'}
                />
              }
              className="w-24"
              disabled={isCalculatingPremium}
              onClick={(_) => {
                setValues(valuesBeforeEdit);
                setShowCovers(false);
                setResultPremiumError(null);
                setShowCalculatePremiumButton(false);
                setPremiumData(null);
                setWarningMsg(null);
                document.body.classList.remove('overflow-y-hidden');
              }}
            >
              Cancel
            </Button>
          </span>
        </div>
      </Modal>
    </div>
  );
}
